import has from 'lodash-es/has';
import { PageConfig, PageStyle } from '../../components/page-view-m/types';
import { LayoutType, pageViewClsPrefix } from '../../constants';
import ebdcoms from '../ebdcoms';
import { StyleConfigAttrs } from './types';

const dftCardStyle = {
  rowSpace: 10,
};
export const MDftPageStyle = {
  [LayoutType.GridLayout]: {
    padding: {
      space: '10px 15px 10px 15px',
      selectedId: 'default',
    },
  },
  [LayoutType.FlowLayout]: {
    padding: {
      space: '0px 0px 0px 0px',
      selectedId: 'default',
    },
  },
};

const getPageStyle = (layoutType: LayoutType, style?: PageStyle) => {
  const pageStyle = style || { ...MDftPageStyle[layoutType] };
  const { padding } = pageStyle;

  if (padding?.selectedId === 'default' || !padding?.space) {
    pageStyle.padding = {
      ...MDftPageStyle[layoutType].padding,
    };
  }

  return pageStyle;
};

export function formatMConfig(config: PageConfig, layoutType: LayoutType) {
  const {
    cardStyle, style, hasPullRefreshPage = false, pullRefreshComs = [],
  } = config;

  return {
    ...config,
    style: {
      ...config.style,
      page: getPageStyle(layoutType, style?.page),
    },
    cardStyle: {
      ...dftCardStyle,
      ...cardStyle,
    },
    hasPullRefreshPage,
    pullRefreshComs,
  };
}

const getStyles = (
  styleConfig: StyleConfigAttrs,
  layoutType: LayoutType = LayoutType.GridLayout,
) => {
  const { width, margin: marginCfg, padding: paddingCfg } = styleConfig;

  const { background } = styleConfig;

  const padding = paddingCfg?.space
    ? ebdcoms.excu('parseMPSpace')(paddingCfg?.space, 'padding')
    : { padding: MDftPageStyle[layoutType].padding.space };
  const margin = marginCfg?.space
    ? ebdcoms.excu('parseMPSpace')(marginCfg?.space, 'margin')
    : { margin: 'auto' };

  let height = '100%';
  if (has(margin, 'marginBottom') && has(margin, 'marginTop')) {
    height = `calc(100% - ${margin.marginTop} - ${margin.marginBottom})`;
  } else if (has(margin, 'marginBottom') && !has(margin, 'marginTop')) {
    height = `calc(100% - ${margin.marginBottom} * 2)`;
  } else if (has(margin, 'marginTop') && !has(margin, 'marginBottom')) {
    height = `calc(100% - ${margin.marginTop} * 2)`;
  } else if (
    margin.margin === 'auto'
    || (!has(margin, 'marginBottom') && !has(margin, 'marginTop'))
  ) {
    height = '100%';
  } else {
    height = `calc(100% - ${margin.margin} * 2)`;
  }

  const cssProperties = {
    ...styleConfig,
    width: width || (margin?.space && 'auto'),
    ...padding,
    ...margin,
    ...background,
    height,
  };

  return ebdcoms.excu('parseAttrToCss')(cssProperties);
};

/** 初始化页面样式并返回页面class */
export function initMPageStyle(
  styleConfig?: StyleConfigAttrs,
  layoutType: LayoutType = LayoutType.GridLayout,
  pageId?: string,
) {
  const time = Date.now();
  const pageCssAttrs = getStyles(styleConfig || {}, layoutType);

  ebdcoms.excu('createCssText')(
    '',
    pageCssAttrs,
    false,
    undefined,
    `#${pageId}.${pageViewClsPrefix}-container`,
    time,
    `${pageViewClsPrefix}-container`,
    'ebd_page',
  );
}

export default {};
